export type CreateFailureKind = 'retryable' | 'final' | 'uncertain';

export interface CreateFailure {
  kind: CreateFailureKind;
  message: string;
}

// Definite failures where the server rolled the row back and a second
// attempt can pick another node slot, port or generated username.
const RETRYABLE_CODES = new Set(['AGENT_OFFLINE', 'PORT_IN_USE', 'USERNAME_IN_USE']);

// The request may have reached the agent: the proxy could already exist.
const UNCERTAIN_CODES = new Set(['ACK_TIMEOUT', 'DB_ERROR', 'WS_SEND_FAIL']);

export const UNCERTAIN_MESSAGE = '创建结果待确认，请在节点列表核实后再操作';

export function classifyCreateFailure(error: any): CreateFailure {
  const code: string | undefined = error?.response?.data?.error?.code;
  if (!error?.response || !code || UNCERTAIN_CODES.has(code)) {
    return { kind: 'uncertain', message: UNCERTAIN_MESSAGE };
  }
  const message = error.response.data.error.message || '创建失败';
  return { kind: RETRYABLE_CODES.has(code) ? 'retryable' : 'final', message };
}
